import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { MessageType } from '@tencent/dz-models';
import { useConsultModel, useMobileModel, useMessageModel } from '../../hooks';
import styles from './index.less';
import { UIButton } from '@tencent/dz-bricks-ui';
import { TransformType, ReplyType } from '../../const';
import { jsonParseSandbox } from '../../utils';
import { useReportService } from './useReportService';
export var TranformButton = function (props) {
    var moduleParams = props.moduleParams;
    // 获取配置的转化页卡信息
    var config = useConsultModel().getConsultConfig();
    var _a = useComponents(), View = _a.View, Image = _a.Image, Text = _a.Text;
    var messageModel = useMessageModel();
    // 电话咨询
    var mobileModel = useMobileModel();
    var cardComponentConfigObj = config.card_component_config ? jsonParseSandbox(config.card_component_config) : {};
    var buttonType = cardComponentConfigObj.card_component_type || 2;
    var queryParams = new URLSearchParams(window.location.search);
    var query = queryParams.get('query_word') || '';
    var report = useReportService({
        moduleParams: moduleParams,
        palyload: {
            buttonType: buttonType,
            query: query,
        },
    });
    var onClick = function (e) {
        if (buttonType === TransformType.phone) {
            // 电话咨询
            mobileModel.callByComponentId(cardComponentConfigObj.card_component_id);
        }
        else if (buttonType === TransformType.form) {
            report.transformClick();
            messageModel.pushFormMessage(MessageType.MedicaleForm, { source: moduleParams });
        }
        else if (buttonType === TransformType.consult) {
            // 发送问题到输入框
            report.transformClick();
            messageModel.updateInputMessage(query, true);
            // 更新发送框消息来源
            messageModel.updateInputMessageSource({
                // TODO: 更新source
                module: moduleParams,
                payload: {
                    reply_type: ReplyType.consult,
                    reply_content: query,
                },
            });
        }
        // 阻止事件冒泡
        e.stopPropagation();
    };
    return (React.createElement(View, { className: styles['transform-container'], onClick: onClick },
        buttonType === TransformType.phone && (React.createElement(UIButton, { className: styles['transform-button'], icon: React.createElement(Image, { imageHeight: 12, imageWidth: 12, style: { width: 13, height: 13 }, src: "//leads.gdtimg.com/qzone/biz/gdt/fmc_consult/images/transform-tel.png" }) }, "\u7535\u8BDD\u5FEB\u901F\u54A8\u8BE2")),
        buttonType === TransformType.form && (React.createElement(UIButton, { className: styles['transform-button'], icon: React.createElement(Image, { imageHeight: 12, imageWidth: 12, style: { width: 13, height: 13 }, src: "//leads.gdtimg.com/qzone/biz/gdt/fmc_consult/images/transform-form.png" }) }, "\u514D\u8D39\u83B7\u53D6\u8BCA\u7597\u65B9\u6848")),
        buttonType === TransformType.consult && (React.createElement(UIButton, { className: styles['transform-button'], contentStyle: { maxWidth: 'calc(100% - 15px)' }, icon: React.createElement(Image, { imageHeight: 12, imageWidth: 12, style: { width: 13, height: 13 }, src: "//leads.gdtimg.com/qzone/biz/gdt/fmc_consult/images/transform-consult.png" }) },
            React.createElement(Text, { className: styles['transform-button-text'], content: "\u54A8\u8BE2\u201C" + query + "\u201D" })))));
};
